const client =
  window.location.host.startsWith("vw.") ||
  window.location.href.includes("client=vw")
    ? "vw"
    : "cm";

const clientId =
  client === "vw"
    ? process.env.REACT_APP_OKTA_CLIENT_ID_VW
    : process.env.REACT_APP_OKTA_CLIENT_ID;
const oktaDomain = process.env.REACT_APP_OKTA_DOMAIN;

const oktaConfig = {
  clientId: clientId,
  issuer: `${oktaDomain}/oauth2/default`,
  redirectUri: window.location.origin + "/login",
  scopes: ["openid", "profile", "email"],
  pkce: true,
  disableHttpsCheck: true,
};

export default oktaConfig;
